<div>
  <div class="modal-header">
    <h4 class="modal-title">Пакет ТВ каналов «Лайт»</h4>
    <button type="button" class="btn close text-danger" aria-label="Close" (click)="activeModal.close('Cross click')">
      <span><span class="dark-color"><i class="fa fa-times" aria-hidden="true"></i></span></span>
    </button>
  </div>
  <div class="modal-body" style="height: 500px; overflow-y: auto">
    <table  class="table" style="width: 100%">
      <tbody><tr>
        <td> 1</td>
        <td> Первый канал</td>
        <td> 63</td>
        <td> Россия 1 HD</td>
      </tr>
      <tr>
        <td> 2</td>
        <td> Россия 1</td>
        <td> 64</td>
        <td> Первый канал HD</td>
      </tr>
      <tr>
        <td> 3</td>
        <td> Матч ТВ</td>
        <td> 65</td>
        <td> Москва Доверие</td>
      </tr>
      <tr>
        <td> 4</td>
        <td> НТВ</td>
        <td> 66</td>
        <td> Телеканал 360</td>
      </tr>
      <tr>
        <td> 5</td>
        <td> Пятый канал</td>
        <td> 67</td>
        <td> BRIDGE TV CLASSIC</td>
      </tr>
      <tr>
        <td> 6</td>
        <td> Россия К</td>
        <td> 68</td>
        <td> Тномер</td>
      </tr>
      <tr>
        <td> 7</td>
        <td> Россия 24</td>
        <td> 69</td>
        <td> Футбол HD</td>
      </tr>
      <tr>
        <td> 8</td>
        <td> Карусель</td>
        <td> 70</td>
        <td> 8 канал</td>
      </tr>
      <tr>
        <td> 9</td>
        <td> ОТР</td>
        <td> 71</td>
        <td> Paramount Comedy</td>
      </tr>
      <tr>
        <td> 10</td>
        <td> ТВ Центр</td>
        <td> 72</td>
        <td> Развлечение</td>
      </tr>
      <tr>
        <td> 11</td>
        <td> РенТВ</td>
        <td> 73</td>
        <td> СТС Love</td>
      </tr>
      <tr>
        <td> 12</td>
        <td> Спас</td>
        <td> 74</td>
        <td> MTV</td>
      </tr>
      <tr>
        <td> 13</td>
        <td> СТС</td>
        <td> 75</td>
        <td> Вместе-РФ</td>
      </tr>
      <tr>
        <td> 14</td>
        <td> Домашний</td>
        <td> 76</td>
        <td> ЛДПР.ТВ</td>
      </tr>
      <tr>
        <td> 15</td>
        <td> ТВ-3 Россия</td>
        <td> 77</td>
        <td> РЖД ТВ HD</td>
      </tr>
      <tr>
        <td> 16</td>
        <td> Пятница!</td>
        <td> 78</td>
        <td> ТНВ-Татарстан</td>
      </tr>
      <tr>
        <td> 17</td>
        <td> Звезда</td>
        <td> 79</td>
        <td> ТНВ-Планета</td>
      </tr>
      <tr>
        <td> 18</td>
        <td> Мир</td>
        <td> 80</td>
        <td> 9 волна</td>
      </tr>
      <tr>
        <td> 19</td>
        <td> ТНТ</td>
        <td> 81</td>
        <td> Точка ТВ</td>
      </tr>
      <tr>
        <td> 20</td>
        <td> Муз-ТВ</td>
        <td> 82</td>
        <td> ТНТ4</td>
      </tr>
      <tr>
        <td> 21</td>
        <td> Москва 24</td>
        <td> 83</td>
        <td> TOPSHOPTV</td>
      </tr>
      <tr>
        <td> 22</td>
        <td> АИСТ</td>
        <td> 84</td>
        <td> Большая Азия HD</td>
      </tr>
      <tr>
        <td> 23</td>
        <td> Телеканал Санкт-Петербург</td>
        <td> 85</td>
        <td> Просвещение</td>
      </tr>
      <tr>
        <td> 24</td>
        <td> Миллет HD</td>
        <td> 86</td>
        <td> Shopping Live</td>
      </tr>
      <tr>
        <td> 25</td>
        <td> 2x2</td>
        <td> 87</td>
        <td> Калейдоскоп ТВ</td>
      </tr>
      <tr>
        <td> 26</td>
        <td> Disney</td>
        <td> 88</td>
        <td> English club TV</td>
      </tr>
      <tr>
        <td> 27</td>
        <td> Че</td>
        <td> 89</td>
        <td> Красная линия</td>
      </tr>
      <tr>
        <td> 28</td>
        <td> Ювелирочка</td>
        <td> 90</td>
        <td> 7 tv</td>
      </tr>
      <tr>
        <td> 29</td>
        <td> Ю</td>
        <td> 91</td>
        <td> KBS World HD</td>
      </tr>
      <tr>
        <td> 30</td>
        <td> Deutsche Welle</td>
        <td> 92</td>
        <td> Беларусь 24</td>
      </tr>
      <tr>
        <td> 31</td>
        <td> РБК ТВ</td>
        <td> 93</td>
        <td> RTG HD</td>
      </tr>
      <tr>
        <td> 32</td>
        <td> VitrinaTV</td>
        <td> 94</td>
        <td> RT HD</td>
      </tr>
      <tr>
        <td> 33</td>
        <td> Bridge TV</td>
        <td> 95</td>
        <td> Теледом HD</td>
      </tr>
      <tr>
        <td> 34</td>
        <td> СОЮЗ</td>
        <td> 96</td>
        <td> Телеканал 360 HD</td>
      </tr>
      <tr>
        <td> 35</td>
        <td> RT</td>
        <td> 97</td>
        <td> МИР PREMIUM</td>
      </tr>
      <tr>
        <td> 36</td>
        <td> France 24 HD</td>
        <td> 98</td>
        <td> Матч ТВ HD</td>
      </tr>
      <tr>
        <td> 37</td>
        <td> Нано</td>
        <td> 99</td>
        <td> СТРК HD</td>
      </tr>
      <tr>
        <td> 38</td>
        <td> Радость моя</td>
        <td> 100</td>
        <td> 360 Новости</td>
      </tr>
      <tr>
        <td> 39</td>
        <td> Первый образовательный</td>
        <td> 101</td>
        <td> Открытый мир</td>
      </tr>
      <tr>
        <td> 40</td>
        <td> BRIDGE TV Русский Хит</td>
        <td> 102</td>
        <td> Три ангела</td>
      </tr>
      <tr>
        <td> 41</td>
        <td> BRIDGE TV HITS</td>
        <td> 103</td>
        <td> О2ТВ HD</td>
      </tr>
      <tr>
        <td> 42</td>
        <td> Мир 24</td>
        <td> 104</td>
        <td> NHK World Japan HD</td>
      </tr>
      <tr>
        <td> 43</td>
        <td> Shop&amp;Show</td>
        <td> 105</td>
        <td> Известия HD</td>
      </tr>
      <tr>
        <td> 44</td>
        <td> БелРос</td>
        <td> 106</td>
        <td> Домашний магазин</td>
      </tr>
      <tr>
        <td> 45</td>
        <td> Телепутешествия</td>
        <td> 107</td>
        <td> НТВ HD</td>
      </tr>
      <tr>
        <td> 46</td>
        <td> RTG TV</td>
        <td> 108</td>
        <td> ТНТ HD</td>
      </tr>
      <tr>
        <td> 47</td>
        <td> Зоо ТВ</td>
        <td> 109</td>
        <td> ТИВИСИ HD</td>
      </tr>
      <tr>
        <td> 48</td>
        <td> Рыболов</td>
        <td> 110</td>
        <td> Супер</td>
      </tr>
      <tr>
        <td> 49</td>
        <td> Fashion TV</td>
        <td> 111</td>
        <td> ЖАРА</td>
      </tr>
      <tr>
        <td> 50</td>
        <td> Arirang</td>
        <td> 112</td>
        <td> Luxury HD</td>
      </tr>
      <tr>
        <td> 51</td>
        <td> Здоровье</td>
        <td> 113</td>
        <td> ПРО Бизнес</td>
      </tr>
      <tr>
        <td> 52</td>
        <td> ТДК</td>
        <td> 114</td>
        <td> Music Box Gold</td>
      </tr>
      <tr>
        <td> 53</td>
        <td> Ратник HD</td>
        <td> 115</td>
        <td> Пёс и Ко</td>
      </tr>
      <tr>
        <td> 54</td>
        <td> Nickelodeon HD</td>
        <td> 116</td>
        <td> Центральное ТВ</td>
      </tr>
      <tr>
        <td> 55</td>
        <td> Europa Plus TV HD</td>
        <td> 117</td>
        <td> Хабар 24 HD</td>
      </tr>
      <tr>
        <td> 56</td>
        <td> Music Box Russia</td>
        <td> 118</td>
        <td> Казах ТВ HD</td>
      </tr>
      <tr>
        <td> 57</td>
        <td> Euronews</td>
        <td> 119</td>
        <td> Luxury</td>
      </tr>
      <tr>
        <td> 58</td>
        <td> BBC World News</td>
        <td> 120</td>
        <td> СТС HD</td>
      </tr>
      <tr>
        <td> 59</td>
        <td> RTD</td>
        <td> 121</td>
        <td> Домашний HD</td>
      </tr>
      <tr>
        <td> 60</td>
        <td> ТБН</td>
        <td> 122</td>
        <td> Пятница! HD</td>
      </tr>
      <tr>
        <td> 61</td>
        <td> LEOMAX24</td>
        <td> 123</td>
        <td> ТВ-3 HD</td>
      </tr>
      <tr>
        <td> 62</td>
        <td> LEOMAX+</td>
        <td> </td>
        <td> </td>
      </tr>
      </tbody></table>
  </div>
</div>
